module.exports = __webpack_public_path__ + "img/Elder.8ee2565e.png";